<template>
  <div>
    <div
      v-if="!player"
      class="spinner-loader"
    >
      <sync-loader />
      <p>Loading ...</p>
    </div>
    <div
      v-if="player"
      class="content"
    >
      <h1 class="has-text-centered">
        Member Points
      </h1>
      <hr>
      <modale-image
        v-if="showPreview"
        :image="player.general.photo"
        @closeModal="closeModal"
      />
      <div class="columns">
        <avatar
          :photo="player.general.photo"
          @previewImage="previewImage"
        />

        <top-bar
          :player="player"
          :user="user"
          :token="token"
          @message="sendNotification"
          @compare="compare"
        />
      </div>
      <div
        v-if="player.totalPlacements && player.tournamentHistory"
        class="columns"
      >
        <div class="column is-8">
          <point-races :races="races" />
          <tournament-history
            v-if="player.tournamentHistory"
            :player="player"
          />
          <ahl-stars :stars="player.stars"/>
        </div>
        <div class="column is-4">
          <quick-stats
            :tournament-type="tournamentType"
            :player="player"
            @tourntypechanged="tournTypeChanged"
          />

          <overall-placement
            :tournament-type="tournamentType"
            :player="player"
            @tourntypechanged="tournTypeChanged"
          />

          <venue-stats :player="player" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  import Avatar from './Avatar.vue'
  import TopBar from './TopBar.vue'
  import PointRaces from './PointRaces.vue'
  import TournamentHistory from './TournamentHistory.vue'
  import QuickStats from './QuickStats.vue'
  import OverallPlacement from './OverallPlacement.vue'
  import VenueStats from './VenueStats.vue'
  import ModaleImage from '../ModalImage.vue'
  import AhlStars from "@/components/players/AhlStars";

  export default {
    name: 'PlayerDetails',
    metaInfo: {
      title: 'AHL Poker :: Member Points'
    },
    components: {
      Avatar,
      AhlStars,
      TopBar,
      PointRaces,
      TournamentHistory,
      ModaleImage,
      OverallPlacement,
      VenueStats,
      QuickStats
    },
    props: ['user', 'token'],
    data() {
      return {
        player: '',
        comparison: '',
        races: '',
        showPreview: false,
        tournamentType: 'Texas_Holdem'
      }
    },
    mounted() {
      this.selectedYear = this.getCurrentYear()
      this.selectedMonth = this.getCurrentMonth()
      if (this.$route.params.id) {
        let id = this.$route.params.id
        this.$axios({
          method: 'POST',
          url: `general/memberpoints/${id}`,
          headers: {
            Authorization: '84cd7a9a97d4c1d8f6402f9389711560',
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          data: {
            token: this.token || ''
          }
        })
          .then((res) => {
            this.player = res.data
            this.races = Object.entries(res.data.pointRaces)
          })
          .catch((error) => {
            this.$emit('message', {error: true,showDialog: true, message: error.response.data.message})
          })
      }
    },
    methods: {
      tournTypeChanged: function (tournType) {
        this.tournamentType = tournType
      },
      previewImage() {
        this.showPreview = !this.showPreview
      },
      closeModal() {
        this.showPreview = !this.showPreview
      },
      getCurrentMonth() {
        let date = new Date()
        return date.getMonth()
      },
      convertMonth(number) {
        // Number is month 0 - Jan, 1 - Feb, etc. If current month is Nov or Dec turn to Jun and Feb
        if (number === 12) {
          number = 0
        }
        if (number === 13) {
          number = 1
        }
        switch (number) {
          case 0:
            return 'Jan'
          case 1:
            return 'Feb'
          case 2:
            return 'Mar'
          case 3:
            return 'Apr'
          case 4:
            return 'May'
          case 5:
            return 'Jun'
          case 6:
            return 'Jul'
          case 7:
            return 'Aug'
          case 8:
            return 'Sep'
          case 9:
            return 'Oct'
          case 10:
            return 'Nov'
          case 11:
            return 'Dec'
          default:
            return 'Error'
        }
      },
      getCurrentYear() {
        let date = new Date()
        return date.getFullYear()
      },
      compare(comparison) {
        if (comparison) {
          this.comparison = comparison
        }
        let userOne = this.player.general.ahlid
        let userTwo = this.comparison
        if (userTwo) {
          this.$router.push({path: `/comparison/${userOne}/${userTwo}/`, params: {userOne, userTwo}})
        }
      },
      showYear() {
        this.dropdownYear = !this.dropdownYear
      },
      showMonth() {
        this.dropdownMonth = !this.dropdownMonth
      },
      showVenue() {
        this.dropdownVenue = !this.dropdownVenue
      },
      selectYear(year) {
        this.selectedYear = year
      },
      selectMonth(month) {
        this.selectedMonth = month - 1
      },
      sendNotification(message) {
        message.showDialog = true;
        this.$emit('message', message)
      }
    }
  }
</script>
